<template>
	<Layout>
		<div class="wrap">
			<b class="clf">이용약관</b>
			<small class="date">2023.10.01</small>
			<h3>더조인 서비스 이용약관</h3>

			<p>
				<span class="big">제 1장 총칙</span><br />
				<br />
				<b>제1조 (목적)</b><br />
				본 약관은 더조인 홈페이지(이하 "당
				사이트"라 함)가 제공하는 이용조건, 절차,
				이용자와 당 사이트의 권리, 의무,
				책임사항과 기타 필요한 사항을 규정하는
				것을 목적으로 합니다.<br />
				<br />
				<br />
				<b>제2조 (약관의 명시와 개정)</b><br />
				① 본 약관의 내용과 주소지, 대표자명,
				개인정보관리책임자명, 연락처(전화, 팩스,
				전자우편주소 등) 등을 이용자가 알 수
				있도록 당 사이트의 초기화면(전면)에
				게시합니다.<br />
				② 당 사이트는 약관의규제에관한법률,
				전자거래기본법, 전자서명법, 정보통신망이용
				촉진 및 정보보호이용등에관한법률,
				방문판매등에관한법률, 소비자보호법 등
				관련법을 위배하지 않는 범위에서 이 약관을
				개정할 수 있습니다. 약관을 개정할 경우에는
				적용일자 등을 명시하여 현행약관과 함께 당
				사이트에 그 적용일자 7일이전부터 적용일자
				전일까지 공지합니다.<br />
				③ 당 사이트는 귀하가 본 약관 내용에
				동의하는 것을 조건으로 귀하에게 서비스를
				제공할 것이며, 귀하가 본 약관의 내용에
				동의하는 경우, 당 사이트의 서비스 제공
				행위 및 귀하의 서비스 사용 행위에는 본
				약관이 우선적으로 적용될 것입니다.<br />
				④ 이 약관에 동의하는 것은 정기적으로 당
				사이트를 방문하여 약관의 변경사항을
				확인하는 것에 동의함을 의미합니다. 변경된
				약관에 대한 정보를 알지 못해 발생하는
				이용자의 피해는 당 사이트에서 책임지지
				않습니다.<br />
				⑤ 당 사이트 회원은 변경된 약관에 동의하지
				않을 경우 회원 탈퇴(해지)를 요청할 수
				있으며, 변경된 약관의 효력 발생일로부터
				7일 이후에도 거부의사를 표시하지 아니하고
				서비스를 계속 사용할 경우 약관의 변경
				사항에 동의한 것으로 간주됩니다.<br />
				⑥ 본 약관에 명시되지 않은 사항은 관계
				법령에 규정 되어있을 경우 그 규정에
				따르며, 그렇지 않은 경우에는 일반적인
				관례에 따릅니다<br />
				<br />
				<br />
				<b>제3조 (용어의 정의)</b><br />
				이 약관에서 사용하는 용어의 정의는 다음과
				같습니다.<br />
				① 이용자 : 서비스에 가입한 자<br />
				② 이메일 : 이용자 식별과 이용자의 서비스
				이용을 위하여 이용계약 체결시 이용자가
				설정 이메일 주소<br />
				③ 비밀번호 : 이용자의 비밀을 보호하기
				위하여 이용자 자신이 설정한 문자 또는
				숫자의 조합<br />
				④ 단말기 : 서비스 제공을 받기 위해
				이용자가 설치한 개인용 컴퓨터 등의 기기<br />
				⑤ 서비스 이용 : 이용자가 단말기를 이용하여
				당 사이트의 주전산기에 접속하여 정보를
				이용하는 것<br />
				⑥ 이용계약 : 서비스를 제공받기 위하여 이
				약관으로 당 사이트와 이용자간의 체결하는
				계약을 말함<br />
				⑦ 가입 : 당 사이트가 제공하는 신청서
				양식에 해당 정보를 기입하고, 본 약관 등에
				동의하여 서비스 이용계약을 완료시키는
				행위<br />
				⑧ 탈퇴(해지) : 회원이 이용계약을
				종료시키는 행위<br />
				<br />
				<br />
				<span class="big"
					>제 2장 서비스이용계약</span
				><br />
				<br />
				<b>제4조 (이용계약의 성립)</b><br />
				① 만13세 이상이어야 서비스 이용 계약이
				가능합니다.<br />
				② 이용계약은 이용자의 이용신청에 대한
				서비스의 약관 승락에 의해 성립됩니다.<br />
				③ 제1항의 규정에 의해 이용자가 이용 신청을
				할 때에는 정보통신산업진흥원이 이용자
				관리시 필요로 하는 사항을 전자적 방식(당
				사이트의 서버 등 정보처리장치에 접속하여
				데이터를 입력하는 것을 말합니다)이나
				서면으로 하여야 합니다.<br />
				④ 이용계약은 이메일 단위로 체결합니다.<br />
				⑤ 서비스의 대량이용 등 특별한 서비스
				이용에 관한 계약은 별도의 계약으로
				합니다.<br />
				<br />
				<br />
				<b>제5조 (이용신청)</b><br />
				① 서비스를 이용하고자 하는 자는 온라인을
				통해 당 사이트에 게시된 이메일 또는
				유선전화번호로 서비스 이용에 대한 문의
				절차 후 이용 가능합니다.<br />
				② 서비스를 이용하고자 회원으로 가입하기
				위해서는 이용신청을 하고 당 사이트
				이용자의 개인정보보호지침과 본 약관에
				동의를 하여야 합니다.<br />
				③ 회원가입 이후 당 사이트에서 제공하는
				서비스를 제공받을 의사가 없는 등의 사유가
				있는 경우에는 회원탈퇴(해지) 할 수
				있습니다.<br />
				<br />
				<br />
				<b>제6조 (이용계약 승낙의 유보)</b><br />
				1. 당 사이트는 다음 각 호에 해당하는
				경우에는 이용계약의 승낙을 유보할 수
				있습니다.<br />
				① 설비에 여유가 없는 경우<br />
				② 기술상에 지장이 있는 경우<br />
				③ 기타 서비스의 효율적인 운영 등을 위하여
				필요하다고 인정되는 경우<br />
				2. 당 사이트는 다음 각 호에 해당하는
				이용계약 신청에 대하여는 이를 거절할 수
				있습니다.<br />
				① 다른 사람의 명의를 사용하여 이용신청을
				하였을 때<br />
				② 이용계약 신청서의 내용을 허위로
				기재하였을 때<br />
				③ 사회의 안녕, 질서 혹은 미풍양속을 저해할
				목적으로 이용신청을 한 때<br />
				<br />
				<br />
				<b>제7조 (계약사항의 변경)</b><br />
				이용자는 다음 사항을 변경하고자 하는 경우
				서비스에 접속하여 서비스 내의 기능을
				이용하여 변경할 수 있습니다.<br />
				① 개인 이력사항<br />
				② 비밀번호<br />
				③ 기타 정보통신산업진흥원이 인정하는
				사항<br />
				<br />
				<br />
				<br />
				<span class="big"
					>제 3장 서비스의 이용</span
				><br />
				<br />
				<b>제8조 (서비스 이용시간)</b><br />
				서비스의 이용 시간은 당 사이트의 업무 및
				기술상 특별한 지장이 없는 한 연중무휴, 1일
				24시간(00:00-24:00)을 원칙으로 합니다.
				다만 정기점검 등의 필요로 당 사이트가 정한
				날이나 시간은 그러하지 아니합니다.<br />
				<br />
				<br />
				<b>제 9조(이용자의 정보보안 등)</b><br />
				① 이용자의 이메일 및 비밀번호에 대한 모든
				관리책임은 이용자에게 있습니다.<br />
				② 명백한 사유가 있는 경우를 제외하고는
				이용자가 이메일을 공유, 양도 또는 변경할
				수 없습니다.<br />
				③ 이용자가 서비스를 이용하기 위해 입력한
				이메일에 의하여 발생되는 서비스 이용 상의
				과실 또는 제3자에 의한 부정사용 등에 대한
				모든 책임은 이용자에게 있습니다.<br />
				<br />
				<br />
				<b>
					제 10조 (서비스 이용의 제한 및
					이용계약의 해지) </b
				><br />
				1. 이용자가 서비스 이용계약을 해지하고자
				하는 때에는 당 사이트에 게시된 이메일 또는
				유선전화번호로 서비스 이용에 대한
				해지신청을 하여야 합니다.<br />
				2. 이용자가 다음 각 호에 해당하는 경우
				사전통지 없이 이용계약을 해지하거나 전부
				또는 일부의 서비스 제공을 중지할 수
				있습니다.<br />
				① 타인의 이용자번호를 사용한 경우<br />
				② 다량의 정보를 전송하여 서비스의 안정적
				운영을 방해하는 경우<br />
				③ 수신자의 의사에 반하는 광고성 정보,
				전자우편을 전송하는 경우<br />
				④ 정보통신설비의 오작동이나 정보 등의
				파괴를 유발하는 컴퓨터 바이러스
				프로그램등을 유포하는 경우<br />
				⑤ 정보통신윤리위원회로부터의 이용제한 요구
				대상인 경우<br />
				⑥ 선거관리위원회의 유권해석 상의
				불법선거운동을 하는 경우<br />
				⑦ 서비스를 통해 얻은 정보를 당 사이트의
				동의없이 상업적으로 이용하는 경우<br />
				⑧ 기타 당 사이트가 부적당하다고 판단하는
				경우<br />
				3. 전항의 규정에 의하여 이용자의 이용을
				제한하는 경우와 제한의 종류 및 기간 등
				구체적인 기준은 공지, 서비스 이용안내
				등에서 별도로 정하는 바에 의합니다.<br />
				<br />
				<br />
				<b>
					제 11조 (이용자 게시물의 삭제 및 서비스
					이용제한) </b
				><br />
				1. 당 사이트는 서비스용 설비의 용량에
				여유가 없다고 판단되는 경우 필요에 따라
				이용자가 게재 또는 등록한 내용물을 삭제할
				수 있습니다.<br />
				2. 당 사이트는 서비스용 설비의 용량에
				여유가 없다고 판단되는 경우 이용자의
				서비스 이용을 부분적으로 제한할 수
				있습니다.<br />
				3. 제 1 항 및 제 2 항의 경우에는 당해
				사항을 사전에 온라인을 통해서
				공지합니다.<br />
				4. 당 사이트는 이용자가 게재 또는 등록하는
				서비스내의 내용물이 다음 각호에 해당한다고
				판단되는 경우에 이용자에게 사전 통지없이
				삭제할 수 있습니다.<br />
				① 다른 이용자 또는 제 3자를 비방하거나
				중상모략으로 명예를 손상시키는 경우<br />
				② 공공질서 및 미풍양속에 위반되는 내용의
				정보, 문장, 도형 등을 유포하는 경우<br />
				③ 반국가적, 반사회적, 범죄적 행위와
				결부된다고 판단되는 경우<br />
				④ 다른 이용자 또는 제3자의 저작권 등 기타
				권리를 침해하는 경우<br />
				⑤ 게시 기간이 규정된 기간을 초과한 경우<br />
				⑥ 이용자의 조작 미숙이나 광고목적으로
				동일한 내용의 게시물을 5회이상 반복
				등록하였을 경우<br />
				⑦ 기타 관계 법령에 위배된다고 판단되는
				경우<br />
				<br />
				<br />
				<b>제 12조 (서비스 제공의 중지 및 제한)</b
				><br />
				1. 당 사이트는 다음 각 호에 해당하는 경우
				서비스 제공을 중지할 수 있습니다.<br />
				① 서비스용 설비의 보수 또는 공사로 인한
				부득이한 경우<br />
				② 전기통신사업법에 규정된 기간통신사업자가
				전기통신 서비스를 중지했을 때<br />
				2. 당 사이트는 국가비상사태, 서비스 설비의
				장애 또는 서비스 이용의 폭주 등 으로
				서비스 이용에 지장이 있는 때에는 서비스
				제공을 중지하거나 제한할 수 있습니다.<br />
				<br />
				<br />
				<b>제 13조 (당 사이트의 의무)</b><br />
				① 당 사이트는 서비스용 설비를 지속적이고
				안정적인 서비스 제공에 적합하도록
				유지하여야 하며 서비스용 설비에 장애가
				발생하거나 또는 그 설비가 못쓰게 된 경우
				그 설비를 수리하거나 복구합니다.<br />
				② 당 사이트는 서비스 내용의 변경 또는
				추가사항이 있는 경우, 해당사항을 당
				사이트에 공지합니다.<br />
				<br />
				<br />
				<b>제 14조 (개인정보보호)</b><br />
				1. 당 사이트는 정보통신이용촉진등에 관한
				법률등 관계법령에 따라 제공받는 이용자의
				개인정보 및 서비스 이용 중 생성되는
				개인정보를 보호하여야 합니다.<br />
				2. 당 사이트의 관리책임자는 관리담당
				부서장이며, 개인정보 관리책임자의 성명은
				별도로 공지하거나 서비스 안내에
				게시합니다.<br />
				3. 이용자가 자신의 개인정보를 전송 등의
				방법으로 당 사이트에 제공하는 행위는 당
				사이트의 개인정보 수집 및 이용 등에
				동의하는 것으로 간주되며, 당 사이트의
				이용자 개인정보의 수집 및 이용목적은 다음
				각 호와 같습니다.<br />
				① 서비스 제공 등 이용계약의 이행<br />
				② 마케팅 정보 생성 및 이용 고객별 안내<br />
				③ 광고 전송 또는 우송<br />
				4. 당 사이트는 개인정보를 이용고객의
				별도의 동의 없이 제3자에게 제공하지
				않습니다. 다만, 다음 각 호의 경우는
				이용고객의 별도 동의 없이 제3자에게
				이용고객의 개인정보를 제공할
				수있습니다.<br />
				① 수사상의 목적에 따른 수사기관의 서면
				요구가 있는 경우에 수사협조의 목적으로
				국가수사 기관에 성명, 주소 등 신상정보를
				제공하는 경우<br />
				② 신용정보의 이용 및 보호에 관한 법률,
				전기통신관련법률 등 법률에 특별한 규정이
				있는 경우<br />
				③ 통계, 학술연구 또는 시장조사를 위하여
				필요한 경우로서 특정 개인을 식별할 수 없는
				형태로 제공하는 경우<br />
				5. 이용자는 자신의 개인정보를 열람할 수
				있으며, 오류 수정 등 변경할 수 있습니다.
				열람 및 변경은 원칙적으로 이용신청과
				동일한 방법으로 하며, 자세한 방법은 당
				사이트의 공지사항안내 등의 정한 바에
				따릅니다.<br />
				6. 이용자는 이용계약을 해지함으로써
				개인정보의 수집 및 이용에 대한 동의, 목적
				이외의 사용에 대한 별도 동의, 제3자 제공에
				대한 별도 동의를 철회할 수 있으며,
				해지방법은 본 약관에서 별도로 규정한 바에
				따릅니다.<br />
				<br />
				<br />
				<b>제 15조 (이용자의 의무)</b><br />
				1. 이용자는 서비스를 이용할 때 다음 각
				호의 행위를 하지 않아야 합니다.<br />
				① 다른 이용자의 이메일을 부정하게 사용하는
				행위<br />
				② 서비스를 이용하여 얻은 정보를 당
				사이트의 사전승낙 없이 이용자의 이용
				이외의 목적으로 복제하거나 이를 출판, 방송
				등에 사용하거나 제3자에게 제공하는 행위<br />
				③ 다른 이용자 또는 제3자를 비방하거나
				중상모략으로 명예를 손상하는 행위<br />
				④ 공공질서 및 미풍양속에 위배되는 내용의
				정보, 문장, 도형 등을 타인에게 유포하는
				행위<br />
				⑤ 반국가적, 반사회적, 범죄적 행위와
				결부된다고 판단되는 행위<br />
				⑥ 다른 이용자 또는 제3자의 저작권등 기타
				권리를 침해하는 행위<br />
				⑦ 기타 관계 법령에 위배되는 행위<br />
				2. 이용자는 이 약관에서 규정하는 사항과
				서비스 이용안내 또는 주의사항을 준수하여야
				합니다.<br />
				3. 이용자가 설치하는 단말기 등은
				전기통신설비의 기술기준에 관한 규칙이
				정하는 기준에 적합하여야 하며, 서비스에
				장애를 주지 않아야 합니다.<br />
				<br />
				<br />
				<span class="big"
					>제 4장 서비스이용요금</span
				><br />
				<br />
				<b>제16조 (이용요금)</b><br />
				당 사이트의 서비스 이용료는 무료로 합니다.
				단, 당 사이트의 정책에 따라 이용 요금이
				유료화될 경우에는 당 사이트의 공지사항안내
				등을 통해 게시합니다.<br />
				<br />
				<br />
				<span class="big">제 5장 저작권</span
				><br />
				<br />
				<b>제17조 (게재된 자료에 대한 권리)</b
				><br />
				당 사이트에 게재된 자료에 대한 권리는 다음
				각 호와 같습니다.<br />
				① 게시물에 대한 권리와 책임은 게시자에게
				있으며, 당 사이트는 게시자의 동의없이는
				이를 영리적 목적으로 사용할 수 없습니다.
				단, 비영리적 목적인 경우, 당 사이트는
				게시자의 동의 없이도 이를 사용할 수 있으며
				서비스내의 게재권을 갖습니다.<br />
				② 게시자의 사전 동의가 없이는 이용자는
				서비스를 이용하여 얻은 정보를 가공,
				판매하는행위 등 서비스에 게재된 자료를
				상업적 목적으로 이용할 수 없습니다.<br />
				<br />
				<br />
				<span class="big"
					>제 6장 이의 신청 및 손해배상 청구
					금지</span
				><br />
				<br />
				<b>제18조 (이의신청금지)</b><br />
				이용자는 당 사이트에서 제공하는 서비스
				이용 시 발생되는 어떠한 문제에 대해서도
				무료 이용 기간 동안은 이의 신청 및 민원을
				제기할 수 없습니다.<br />
				<br />
				<br />
				<b>제19조 (손해배상청구금지)</b><br />
				이용자는 당 사이트에서 제공하는 서비스
				이용 시 발생되는 어떠한 문제에 대해서도
				무료 이용 기간 동안은 정보통신산업진흥원
				및 관계 기관에 손해배상 청구를 할 수
				없으며 정보통신산업진흥원은 이에 대해
				책임을 지지 아니합니다.<br />
				<br />
				<br />
				<br />
				부칙<br />
				<br />
				1. (시행일) 이 약관은 2023년 10월 1일부터
				시행합니다.<br />
				* 본 약관에 대한 저작권은
				정보통신산업진흥원에 귀속하며 무단 복제,
				배포, 전송, 기타 저작권 침해행위를
				엄금합니다.
			</p>
		</div>
	</Layout>
</template>

<style lang="scss" scoped>
.wrap {
	width: 100%;
	margin: 140px auto 120px;
	max-width: 1080px;
	text-align: center;
	.clf {
		@include BodyMB($brandL1);
		margin-right: 10px;
	}
	.date {
		@include BodyM($gray5);
	}
	b {
		font-weight: 500;
	}
	h3 {
		padding: 14px 0 48px;
		margin-bottom: 48px;
		@include D3();
		display: block;
		border-bottom: 1px solid #e7e7ef;
	}
	p {
		text-align: left;
		@include BodyM();
	}
	.big {
		@include BodyLB();
	}
}

// 태블릿
@media screen and (max-width: $tabletW) {
	.wrap {
		max-width: 660px;
		h3 {
			padding: 10px 0 40px;
			margin-bottom: 39px;
			@include T3();
		}
	}
}
// 모바일
@media screen and (max-width: $mobileW) {
	.wrap {
		margin: 60px auto 80px;
		padding: 0 20px;
		.clf {
			@include BodySB($brandL1);
		}
		small {
			@include BodyS($gray5);
		}
		h3 {
			padding: 6px 0 24px;
			margin-bottom: 17px;
			@include M3();
		}
		p {
			@include BodyS();
		}
		.big {
			@include BodyMB();
		}
	}
}
</style>
